import React from 'react'

const About = () => {
  return (
    <div  className="tw-mt-[150px]">
         <div className="tw-w-[80%] sm:tw-w-[95%] tw-mx-auto tw-my-4 tw-p-2 tw-overflow-hidden tw-rounded-md" data-aos="fade-left" data-aos-duration="700">
         <div className="tw-font-bold tw-text-2xl sm:tw-text-xl tw-text-second-zain tw-mt-4 tw-p-2">
                <span className="tw-whitespace-nowrap tw-overflow-hidden tw-text-second-zain tw-font-bold tw-text-xl md:tw-text-lg sm:tw-text-sm tw-py-3 tw-px-2 tw-pr-4 tw-rounded-sm tw-shadow-sm tw-border-r-2 tw-border-second-zain">
                 منصة السجانة
                </span>
            </div>
            <div className=" tw-shadow-md tw-rounded-sm tw-max-h-[600px] tw-overflow-auto tw-p-2 tw-border-gray-50 tw-mt-4 tw-border-t-2 tw-border-t-second-zain">
              
          <div className="tw-text-gray-500 tw-p-3 ">
            <p>
            منصة إخبارية تُعني بنشر وتحديث أسعار مواد البناء والتشييد بصورة راتبة ومستمرة بالإضافة للعديد من المقالات المكتوبة والمرئية عن مواضيع البناء والتشييد في السودان والاخطاء الشائعة فيما يخص البناء والتشييد وتقديم عروض الشراء من أفضل الشركات والحرفيين والموردين .
                </p> 
          </div>
          </div>
          </div>
    </div>
  )
}

export default About